<div class="edit-perfil-container w-full">
    <h2 mat-dialog-title class="dialog-title">Editar foto de Perfil</h2>
    <div mat-dialog-content class="dialog-content">
        <div class="current-avatar-section">
            <img [src]="currentAvatar" alt="Avatar actual" class="avatar"/>
            <div class="tooltip">Este es tu ícono de perfil actual. Para cambiarlo, selecciona un avatar o sube tu imagen desde tu ordenador. Antes de irte, guarda los cambios.</div>
        </div>
        <button mat-button class="upload-button" color="primary" (click)="uploadAvatar()">Subir foto</button>
        <div class="avatar-options">
            <div 
                class="avatar-option"
                *ngFor="let avatar of defaultAvatars"
                (click)="selectAvatar(avatar)
            ">
                <img
                    [src]="avatar"
                    alt="Opción de avatar"
                    class="avatar"
                    [class.selected]="avatar === selectedAvatar"
                />
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button 
            mat-raised-button
            class="dialog-actions-button cancel"
            color="primary" 
            (click)="closeDialog()">
            Cerrar
        </button>
        <button 
            mat-raised-button
            class="dialog-actions-button save"
            color="primary"
            type="submit"
            [disabled]="!selectedAvatar"
            (click)="saveChanges()">
            Guardar
        </button>
    </div>
</div>